import { render, staticRenderFns } from "./responsive-img.vue?vue&type=template&id=32ceea72"
import script from "./responsive-img.vue?vue&type=script&lang=js"
export * from "./responsive-img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports